var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJointacademySymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 60,
    viewBox: "0 0 48 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2465_32718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2293 0C28.6372 0.0795372 32.1635 3.65871 32.0834 7.95372C32.0032 12.2487 28.5571 15.6688 24.2293 15.7484C19.8215 15.6688 16.2952 12.0897 16.3753 7.79465C16.3753 3.49964 19.9016 0 24.2293 0ZM22.8669 22.1114C28.4769 20.6001 34.1671 27.0427 29.3585 34.5192C26.1528 39.53 27.7556 43.9046 24.7903 44.6999C19.6612 45.893 11.727 24.9747 22.8669 22.1114ZM0.907707 16.4642C-1.3363 19.0889 0.667278 23.7816 5.95672 23.0658C9.48302 22.6681 11.4866 24.577 12.6086 23.2249C14.6122 20.8388 5.23543 11.2943 0.907707 16.4642ZM4.19357 49.0745C2.27014 46.8474 4.03329 42.791 8.5213 43.4273C11.5667 43.825 13.3299 42.0752 14.2115 43.3478C16.0547 45.4158 7.9603 53.5286 4.19357 49.0745ZM46.5091 9.78308C49.5546 12.5669 47.9517 18.4526 41.5402 18.4526C37.2125 18.4526 35.2089 21.1569 33.6061 19.6457C30.8812 17.021 40.4984 4.21547 46.5091 9.78308ZM37.0522 59.6529C40.0977 58.3008 40.4182 53.5286 35.6097 51.7787C32.4039 50.5857 31.5224 48.0405 29.9195 48.7563C27.1145 49.9494 30.9614 62.1981 37.0522 59.6529Z",
    fill: "#5096E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2465_32718"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJointacademySymbol);
export default __webpack_public_path__ + "static/media/jointacademy_symbol.bb3803ddc1cf4155a1e6f887c3edd9ec.svg";
export { ForwardRef as ReactComponent };